export default {
  "brand.name": "Basetao Spreadsheet",
  "nav.home": "Home",
  "nav.guide": "Shopping Guide",
  "nav.review": "Review",
  "nav.shipping": "Shipping",
  "nav.qc": "QC",
  "nav.articles": "Articles",
  "cta.explore": "Explore Basetao Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.brand": "Basetao Spreadsheet",
  "cta.readGuide": "Read the Full Guide",
  "cta.backHome": "Back to Home",
  "cta.visitMain": "Visit Our Main Website",
  "footer.tagline": "Independent Basetao Spreadsheet resources, guides and product research tools.",
  "footer.disclaimer": "This is an independent informational resource. Information may change and should be independently verified. We are not affiliated with, endorsed by, or connected to any third-party service mentioned.",
  "footer.rights": "All rights reserved.",
  "footer.resources": "Resources",
  "footer.legal": "Legal",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",
};